// @file Helper class to work with mentions
import type { UserMentionSuggestion } from '@@/types'

/**
 * This constant should be synchronized with
 * `DEFAULT_PAGE_SIZE` in `Api::MentionSuggestionsController`.
 */
const MENTION_SUGGESTIONS_LIMIT = 5

class SelectedMentionSuggestionKeyboardEvent extends KeyboardEvent {
  selectedSuggestion: UserMentionSuggestion

  constructor(type: string, eventInitDict: KeyboardEventInit, selectedSuggestion: UserMentionSuggestion) {
    super(type, eventInitDict)
    this.selectedSuggestion = selectedSuggestion
  }
}

export { MENTION_SUGGESTIONS_LIMIT, SelectedMentionSuggestionKeyboardEvent }
